<script setup>
import { onMounted } from 'vue'
import PrestationOrder from './PrestationOrder.vue'
import ModalBeneficiaire from './ModalBeneficiaire.vue'
import ModalDate from './ModalDate.vue'
import ToursModal from './ToursModal.vue'
import { usePrestationStore } from '../../stores/prestationStore'

const prestationStore = usePrestationStore()

onMounted(() => {
  console.log('onMounted')
  prestationStore.fetchPrestations()
})
</script>

<template>
  <div class="customer-prestations">

    <div v-if="prestationStore.loading.prestations">
      <div class="text-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>

    <!-- Section Prestations à venir -->
    <div class="prestations-section mb-5">
      <div class="prestations-grid">
        <PrestationOrder 
          v-for="prestation in prestationStore.prestations" 
          :key="prestation.id"
          :prestation="prestation" 
        />
      </div>
    </div>

    <!-- Modals -->
    <ModalBeneficiaire />
    <ModalDate />
    <ToursModal />
  </div>
</template>

<style scoped>
.prestations-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1rem;
}

/* Responsive design */
@media (max-width: 992px) {
  .prestations-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .prestations-grid {
    grid-template-columns: 1fr;
  }
}
</style> 